import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "video" }
const _hoisted_3 = {
  class: "video-vid",
  autoplay: "",
  loop: "",
  muted: "",
  playsinline: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "content-bio" }
const _hoisted_7 = { class: "clients-wrapper" }
const _hoisted_8 = { class: "clients-text" }
const _hoisted_9 = { class: "links" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", _hoisted_3, [
        _createElementVNode("source", {
          type: "video/mp4",
          src: _ctx.getVideo
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createTextVNode(" Video isn't working ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.about.about), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client) => {
        return (_openBlock(), _createElementBlock("div", {
          key: client,
          class: "clients"
        }, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(client), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        href: _ctx.mail.link
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: _ctx.mail.icon
        }, null, 8, ["icon"])
      ], 8, _hoisted_10),
      _createElementVNode("a", {
        href: _ctx.insta.link
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: _ctx.insta.icon
        }, null, 8, ["icon"])
      ], 8, _hoisted_11)
    ])
  ]))
}